@if (data(); as data) {
  <div class="flex flex-col gap-6 text-sm">
    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Zamówienie #{{ data.number }}</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Status zamówiania">
            <app-order-status [status]="data.status" />
          </app-details-view>

          <app-details-view label="Data zamówienia">
            <app-date [date]="data.createdAt" />
          </app-details-view>

          <app-details-view label="Łączna kwota">
            @if (isNil(data.refundSummary)) {
              <app-currency [amount]="data.totalPrice" />
            } @else {
              <app-refunded-price
                [currentPrice]="data.refundSummary.currentPrice"
                [refundedPrice]="data.refundSummary.refundedPrice"
                [originalPrice]="data.refundSummary.originalPrice" />
            }
          </app-details-view>

          @if (isNotNil(data.invoice)) {
            <app-details-view label="Faktura">
              <div
                class="text-[#3858E9] underline decoration-dotted"
                role="button"
                (click)="handleDownloadInvoiceClick()">
                {{ data.invoice.number }}
              </div>
            </app-details-view>
          } @else {
            @if (isNotNil(data.temporaryInvoice)) {
              <app-details-view label="Proforma">
                <div
                  class="text-[#3858E9] underline decoration-dotted"
                  role="button"
                  (click)="handleDownloadTemporaryInvoiceClick()">
                  {{ data.temporaryInvoice.number }}
                </div>
              </app-details-view>
            }
          }
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Szczegóły zamówienia</h5>

      <p-divider appPrimengDivider />

      <div class="flex flex-col gap-3">
        <app-details-view label="Zamówione produkty">
          <div class="flex flex-col gap-3">
            @for (
              item of data.items;
              track 'product' + index;
              let index = $index;
              let count = $count
            ) {
              <div class="relative flex flex-col gap-4 bg-gray-50 p-6">
                @if (count > 1) {
                  <div
                    class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                    {{ index + 1 }}.
                  </div>
                }

                @if (isNotNil(item.featuredFile)) {
                  <div>
                    <app-image-thumbnail size="md">
                      <img
                        [fill]="true"
                        [ngSrc]="item.featuredFile.url"
                        [alt]="item.featuredFile.alt" />
                    </app-image-thumbnail>
                  </div>
                }

                <div class="flex flex-1 items-baseline justify-between gap-3">
                  <div class="flex items-center gap-3">
                    <div class="flex flex-col">
                      @if (item.canShowNameAsLink) {
                        <app-public-product-name
                          [slug]="item.slug!"
                          [type]="item.type!">
                          <div class="font-bold hover:underline">
                            {{ item.name }}
                          </div>
                        </app-public-product-name>
                      } @else {
                        <div class="font-bold">{{ item.name }}</div>
                      }

                      @if (isNotNil(item.subName)) {
                        <div class="text-sm">{{ item.subName }}</div>
                      }
                    </div>

                    <div class="flex items-center gap-1">
                      @if (isNil(item.refundSummary)) {
                        <div class="text-xs">x</div>
                        <div class="text-xs">
                          <app-number
                            [value]="item.quantity"
                            unit="szt." />
                        </div>
                      } @else {
                        <app-refunded-quantity
                          [currentQuantity]="item.refundSummary.currentQuantity"
                          [originalQuantity]="
                            item.refundSummary.originalQuantity
                          "
                          [refundedQuantity]="
                            item.refundSummary.refundedQuantity
                          " />
                      }
                    </div>
                  </div>

                  <div class="ms-auto flex items-center font-bold">
                    @if (isNil(item.refundSummary)) {
                      <app-currency [amount]="item.price" />
                    } @else {
                      <app-refunded-price
                        [refundedPrice]="item.refundSummary.refundedPrice"
                        [originalPrice]="item.refundSummary.originalPrice"
                        [currentPrice]="item.refundSummary.currentPrice" />
                    }
                  </div>
                </div>

                @if (item.componentGroups.length) {
                  <div
                    class="flex flex-col gap-3 rounded-md border border-[#ece8e4] bg-white p-4">
                    <div
                      class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
                      Kosmetyki z ankiety
                    </div>

                    <div class="flex flex-col gap-3">
                      @for (
                        group of item.componentGroups;
                        track group.name
                      ) {
                        <section
                          class="flex flex-col gap-3 rounded-md border border-gray-200 bg-gray-50 p-4">
                          <div
                            class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
                            {{ group.name }}
                          </div>

                          @if (group.isRandomSelected) {
                            <div
                              class="rounded-md border border-dashed border-gray-300 bg-white p-3 text-sm font-medium text-gray-500">
                              Losowo dobrane kosmetyki
                            </div>
                          } @else {
                            <div class="grid gap-3 lg:grid-cols-2">
                              @for (
                                component of group.components;
                                track 'component_' +
                                  component.sourceId +
                                  '_' +
                                  component.name +
                                  '_' +
                                  $index
                              ) {
                                <article
                                  class="flex gap-3 rounded-md border border-white bg-white p-3">
                                  @if (isNotNil(component.featuredFile)) {
                                    <div class="shrink-0">
                                      <app-image-thumbnail size="sm">
                                        <img
                                          [fill]="true"
                                          [ngSrc]="component.featuredFile.url"
                                          [alt]="component.featuredFile.alt" />
                                      </app-image-thumbnail>
                                    </div>
                                  }

                                  <div class="flex flex-1 flex-col gap-2">
                                    <div
                                      class="flex items-start justify-between gap-3">
                                      <div class="flex flex-col">
                                        @if (component.sourceName) {
                                          <div
                                            class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
                                            {{ component.sourceName }}
                                          </div>
                                        }

                                        <div class="font-semibold">
                                          {{ component.name }}
                                        </div>
                                      </div>

                                      <div class="text-xs text-gray-500">
                                        x {{ component.quantity }} szt.
                                      </div>
                                    </div>

                                    @if (component.attributes.length) {
                                      <div class="flex flex-col gap-1 text-sm">
                                        @for (
                                          attribute of component.attributes;
                                          track attribute.id
                                        ) {
                                          <div class="flex gap-1">
                                            <span class="font-medium"
                                              >{{ attribute.label }}:</span
                                            >
                                            <span>{{ attribute.value }}</span>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </article>
                              }
                            </div>
                          }
                        </section>
                      }
                    </div>
                  </div>
                }
              </div>
            } @empty {
              <app-no-data />
            }
          </div>
        </app-details-view>

        <div class="flex flex-col gap-3 bg-gray-50 px-6 py-3">
          @for (
            shipment of data.shipments;
            track 'shipment-price' + index;
            let index = $index
          ) {
            <div
              class="grid grid-cols-1 items-center justify-between gap-3 bg-gray-50 xl:grid-cols-3">
              <div class="font-bold">
                <app-router-link
                  [route]="Route.PL_AccountOrderDetails"
                  [params]="params()"
                  fragment="dostawa-{{ index + 1 }}">
                  <span class="hover:underline">{{ shipment.methodName }}</span>
                </app-router-link>
              </div>

              <div class="flex gap-1">
                <span>Status:</span>
                <div class="font-bold">
                  <app-shipment-status [status]="shipment.status" />
                </div>
              </div>

              <div class="ms-auto font-bold">
                @if (isNil(shipment.refundSummary)) {
                  <app-currency [amount]="shipment.price" />
                } @else {
                  <app-refunded-price
                    [refundedPrice]="shipment.refundSummary.refundedPrice"
                    [originalPrice]="shipment.refundSummary.originalPrice"
                    [currentPrice]="shipment.refundSummary.currentPrice" />
                }
              </div>
            </div>
          } @empty {
            <app-no-data />
          }

          <p-divider appPrimengDivider />

          <div class="flex items-center gap-3">
            <div class="font-bold">Łącznie</div>

            <div class="ms-auto font-bold">
              @if (isNil(data.refundSummary)) {
                <app-currency [amount]="data.totalPrice" />
              } @else {
                <app-refunded-price
                  [currentPrice]="data.refundSummary.currentPrice"
                  [refundedPrice]="data.refundSummary.refundedPrice"
                  [originalPrice]="data.refundSummary.originalPrice" />
              }
            </div>
          </div>
        </div>

        <app-details-view label="Metoda płatności">
          <div class="flex flex-col gap-3">
            @for (payment of data.payments; track payment) {
              <div
                class="grid grid-cols-1 items-center justify-between gap-3 bg-gray-50 p-6 xl:grid-cols-3">
                <div class="flex gap-1">
                  <span class="font-bold">{{ payment.paymentMethodName }}</span>
                </div>

                <div class="flex gap-1">
                  <span>Status:</span>
                  <div class="font-bold">
                    <app-payment-status [status]="payment.status" />
                  </div>
                </div>

                <div class="ms-auto flex items-center gap-1">
                  <span>Nr płatności: </span>
                  <span class="font-bold">{{ payment.number }}</span>
                </div>
              </div>
            } @empty {
              <app-no-data />
            }
          </div>
        </app-details-view>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Adres rozliczeniowy</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Imie i nazwisko">
            <div class="flex gap-1">
              <span>{{ data.billingAddress.firstName }}</span>
              <span>{{ data.billingAddress.lastName }}</span>
            </div>
          </app-details-view>

          <app-details-view label="Adres e-mail">
            {{ data.billingAddress.email }}
          </app-details-view>

          <app-details-view label="Numer telefonu">
            {{ data.billingAddress.phone.numberWithPrefix }}
          </app-details-view>

          <app-details-view label="Adres">
            {{ data.billingAddress.asString }}
          </app-details-view>

          <app-details-view label="Nazwa firmy">
            @if (isNotNil(data.billingAddress.companyName)) {
              {{ data.billingAddress.companyName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="NIP firmy">
            @if (isNotNil(data.billingAddress.companyNip)) {
              {{ data.billingAddress.companyNip }}
            } @else {
              <app-no-data />
            }
          </app-details-view>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5 [attr.id]="'lista-przesylek'">Lista przesyłek</h5>

      <p-divider appPrimengDivider />

      <div class="flex flex-col gap-3">
        @for (
          shipment of data.shipments;
          track 'shipment' + index;
          let index = $index;
          let count = $count
        ) {
          <div
            [attr.id]="'dostawa-' + (index + 1)"
            class="relative flex flex-col gap-1 bg-gray-50 p-6">
            @if (count > 1) {
              <div
                class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                {{ index + 1 }}.
              </div>
            }

            <div>
              <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
                <app-details-view label="Imie i nazwisko">
                  <div class="flex gap-1">
                    <span>{{ shipment.address.firstName }}</span>
                    <span>{{ shipment.address.lastName }}</span>
                  </div>
                </app-details-view>

                <app-details-view label="Adres e-mail">
                  {{ shipment.address.email }}
                </app-details-view>

                <app-details-view label="Numer telefonu">
                  {{ shipment.address.phone.numberWithPrefix }}
                </app-details-view>

                <app-details-view label="Adres">
                  {{ shipment.address.asString }}
                </app-details-view>

                <app-details-view label="Nazwa firmy">
                  @if (isNotNil(shipment.address.companyName)) {
                    {{ shipment.address.companyName }}
                  } @else {
                    <app-no-data />
                  }
                </app-details-view>
              </div>
            </div>

            <p-divider
              appPrimengDivider
              class="mx-auto w-4/5" />

            <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
              <app-details-view label="Sposób dostawy">
                {{ shipment.methodName }}
              </app-details-view>

              @if (isNotNil(shipment.address.shippingPointName)) {
                <div class="col-span-2">
                  <app-details-view label="Punkt dostawy">
                    {{ shipment.address.shippingPointName }}
                  </app-details-view>
                </div>
              }

              <app-details-view label="Status">
                <app-shipment-status [status]="shipment.status" />
              </app-details-view>

              @if (isNotNil(shipment.scheduledShippingDate)) {
                <app-details-view label="Planowana data wysyki">
                  <app-date-month-with-year
                    [date]="shipment.scheduledShippingDate" />
                </app-details-view>
              }

              @if (isNotNil(shipment.trackingUrl)) {
                <div class="lg:col-span-2 xl:col-span-3">
                  <app-details-view label="Adres do śledzenia przesyłki">
                    <app-external-link
                      [link]="shipment.trackingUrl"
                      [underline]="false">
                      <div class="text-[#3858E9] underline decoration-dotted">
                        {{ shipment.trackingUrl }}
                      </div>
                    </app-external-link>
                  </app-details-view>
                </div>
              }
            </div>

            @if (shipment.canBeEdited) {
              <p-divider
                appPrimengDivider
                class="mx-auto w-4/5" />
            }

            <div class="flex items-center justify-end gap-2">
              @if (shipment.canBeEdited) {
                <p-button
                  (onClick)="handleShippingAddressUpdateClick(shipment.id)"
                  appPrimengButton
                  size="small"
                  label="Edytuj"
                  severity="info" />
              }
            </div>
          </div>
        } @empty {
          <app-no-data />
        }
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>
        <div class="flex items-center gap-3">
          <div>Lista zwrotów</div>
        </div>
      </h5>

      <p-divider appPrimengDivider />

      <app-public-order-refund-list
        [refunds]="valueOrDefault(data.refunds, [])" />
    </div>
  </div>
} @else {
  <app-spinner-filled />
}

<p-drawer
  [customCloseEvent]="customCloseShippingAddressEditEvent"
  [visible]="shippingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Edycja adresu przesyłki zamówienia</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (shipmentId(); as shipmentId) {
        <app-public-order-shipping-address-edit
          (cancelEvent)="handleCancelShippingAddressEditEvent()"
          (submitEvent)="handleSubmitShippingAddressEditEvent()"
          [shipmentId]="shipmentId"
          [orderNumber]="orderNumber()" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>
